import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'paginationRange',
})
export class PaginationRangePipe implements PipeTransform {
  transform(page: number, pageSize: number, totalSize: number): string {
    if (totalSize === 0) {
      return '0-0 of 0';
    }

    const startIndex = (page - 1) * pageSize + 1;
    const endIndex = Math.min(page * pageSize, totalSize);

    return `${startIndex}-${endIndex} of ${totalSize}`;
  }
}
